import styled from "@emotion/styled"
import { Container, Dialog, IconButton, Typography } from "@mui/material"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"

export const Logo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
`
export const Wrapper = styled.div`
  margin: auto;
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 640px;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.dark};
  font-size: 1.75rem;
  line-height: 100%;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
    font-size: 1.75rem;
    line-height: 2.5rem;
    margin-bottom: 3rem;
  }
`
export const BottomWrapper = styled.div`
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgb(0, 20, 15, 0.1);
`
export const ButtonWrapper = styled.div`
  width: 100%;

  //
  // ${({ theme }) => theme.breakpoints.up("md")} {
  //   display: flex;
  //   justify-content: flex-end;
  // }
`
export const CustomDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 32px;
    border: 1px solid rgba(1, 130, 98, 0.3);
    background: #e5f6f2;
    padding: 1.5rem;

    ${({ theme }) => theme.breakpoints.up("md")} {
      max-width: 859px !important;
      min-width: 859px !important;
      padding: 72px 100px;
    }
  }
`

export const CloseButton = styled(IconButton)`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 10px;
  right: 10px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    top: 0;
    right: 0;
    width: 70px;
    height: 70px;
  }
`
export const Note = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  p {
    color: ${({ theme }) => theme.palette.text.content};
  }
  a {
    margin-left: 0.5rem;
    color: ${({ theme }) => theme.palette.tertiary.dark};
    text-decoration: underline;
  }
`
